// @flow

import React, {createContext, useContext, useMemo, useState} from 'react';

import type {Node} from 'react';

type RelatedProductsOrigin =
  | 'PRODUCT'
  | 'PRODUCT_CATEGORY'
  | 'PRODUCT_SUB_CATEGORY';

type ProductSectionImg = {
  file: File | null,
  preview: string | null,
  imageId?: string,
  productSectionImageLayout?: string,
};

type ImageLayoutType = string | null;
type ProductFormState = {
  // seo
  enabledSeo: boolean,
  setEnabledSeo: ((boolean => boolean) | boolean) => void,
  // size guide
  enabledSizeGuide: boolean,
  setEnabledSizeGuide: ((boolean => boolean) | boolean) => void,
  sizeGuideSelected: string,
  setSizeGuideSelected: string => void,
  // related
  enabledRelatedProducts: boolean,
  setEnabledRelatedProducts: ((boolean => boolean) | boolean) => void,
  relatedProductsOrigin: RelatedProductsOrigin,
  setRelatedProductsOrigin: (val: RelatedProductsOrigin) => void,
  listItems: any[],
  setListItems: (((any[]) => any[]) | any[]) => void,
  listProductsItems: any[],
  setListProductsItems: (((any[]) => any[]) | any[]) => void,
  listCategoryItems: any[],
  setListCategoryItems: (((any[]) => any[]) | any[]) => void,
  listSubcategoriesItems: any[],
  setListSubcategoriesItems: (((any[]) => any[]) | any[]) => void,
  //sections
  sectionImages: ProductSectionImg[],
  setSectionImages: (
    ((ProductSectionImg[]) => ProductSectionImg[]) | ProductSectionImg[]
  ) => void,

  sectionImageLayoutType: string[],
  setSectionImageLayoutType: (
    ((ImageLayoutType[]) => ImageLayoutType[]) | ImageLayoutType[]
  ) => void,
  //new variants
};

const ProductFormContext = createContext<ProductFormState>({});

type Props = {
  children: Node,
};

export const ProductFormProvider = ({children}: Props) => {
  // Related Products section
  const [enabledRelatedProducts, setEnabledRelatedProducts] = useState<boolean>(
    false
  );
  const [
    relatedProductsOrigin,
    setRelatedProductsOrigin,
  ] = useState<RelatedProductsOrigin>('PRODUCT');
  const [listItems, setListItems] = useState([]);
  const [listProductsItems, setListProductsItems] = useState([]);
  const [listCategoryItems, setListCategoryItems] = useState([]);
  const [listSubcategoriesItems, setListSubcategoriesItems] = useState([]);
  // Seo
  const [enabledSeo, setEnabledSeo] = useState<boolean>(false);

  //Sections
  const [enabledSizeGuide, setEnabledSizeGuide] = useState<boolean>(false);
  const [sizeGuideSelected, setSizeGuideSelected] = useState<string>('');

  const [sectionImages, setSectionImages] = useState([]);

  const [sectionImageLayoutType, setSectionImageLayoutType] = useState<
    string[]
  >([]);

  const values = useMemo(() => {
    return {
      enabledSeo,
      setEnabledSeo,
      // size guide
      enabledSizeGuide,
      setEnabledSizeGuide,
      sizeGuideSelected,
      setSizeGuideSelected,
      //related
      enabledRelatedProducts,
      setEnabledRelatedProducts,
      relatedProductsOrigin,
      setRelatedProductsOrigin,
      listItems,
      setListItems,
      listProductsItems,
      setListProductsItems,
      listCategoryItems,
      setListCategoryItems,
      listSubcategoriesItems,
      setListSubcategoriesItems,
      //sections
      sectionImages,
      setSectionImages,
      sectionImageLayoutType,
      setSectionImageLayoutType,

      // new variants
    };
  }, [
    enabledRelatedProducts,
    enabledSeo,
    enabledSizeGuide,
    listCategoryItems,
    listItems,
    listProductsItems,
    listSubcategoriesItems,
    relatedProductsOrigin,
    sectionImageLayoutType,
    sectionImages,
    sizeGuideSelected,
  ]);

  return (
    <ProductFormContext.Provider value={values}>
      {children}
    </ProductFormContext.Provider>
  );
};

export const useProductFormContext = () => {
  return useContext(ProductFormContext);
};
